import { connect } from 'react-redux'

import { setOrder } from '../redux/modules/search/actions'

import ResultsHeader from '../components/ResultsHeader'

const mapStateToProps = (state) => ({
  eventTitle: state.search.eventTitle,
  order: state.search.order,
  totalResults: state.search.pagination.count,
})

const actionCreators = { setOrder }

export default connect(mapStateToProps, actionCreators)(ResultsHeader)



// WEBPACK FOOTER //
// ./src/containers/ResultsHeader.js